import { useTranslation } from "react-i18next";
import { normalizeLocale } from "../../i18n/locales";

// Langue de rédaction faisant foi pour les documents légaux ; les autres langues sont des traductions.
export const LEGAL_SOURCE_LOCALE = "fr";

const TranslationNotice = () => {
  const { t } = useTranslation("public");
  return (
    <div className="max-w-3xl mx-auto">
      <p data-testid="legal-translation-notice" className="text-xs text-slate-500 border-l-2 border-amber-300 pl-3 mb-4">
        <b className="font-semibold text-slate-600">{t("legalCommon.translationNoticeTitle")}</b> — {t("legalCommon.translationNotice")}
      </p>
    </div>
  );
};

// Sélectionne la version du document selon la langue active (registre), repli sur la langue source.
export const localizedLegalPage = (versions) => {
  const LocalizedLegalPage = () => {
    const { i18n } = useTranslation();
    const code = normalizeLocale(i18n.resolvedLanguage);
    const Content = versions[code] || versions[LEGAL_SOURCE_LOCALE];
    return (
      <>
        {versions[code] && code !== LEGAL_SOURCE_LOCALE && <TranslationNotice />}
        <Content />
      </>
    );
  };
  return LocalizedLegalPage;
};
